import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { Outlet } from "react-router-dom-v5-compat";
/**
 * AccountShell - This is the shell wrapper for the entire
 * account page. It contains the navigation and footer.
 * TODO: Move account shell to generic shell for both apps
 * @param {*} { children }
 * @return {*}
 */
const AccountShell = ({ children }) => {
    return (_jsx(Stack, Object.assign({ id: "account-routes", flexGrow: 1 }, { children: children })));
};
/**
 * AccountRoutes - These are all routes for the account portion of the
 * application.
 *
 * @return {*}
 */
export const AccountRoutes = () => {
    return (_jsx(AccountShell, { children: _jsx(Outlet, {}) }));
};
